<template>
   <div class="orderList-tabs-div" >
        <el-row class="tac">
        <el-col :span="12" style="min-width: 200px;height: 360px;">
          <el-menu
            default-active="4" active-text-color='#287EFF' :router='isRouter'  :active="4"
            class="el-menu-vertical-demo">
             <el-menu-item  style="pointer-events: none;height: 60px;line-height: 60px">
               <img src="../../static/images/企业账户.svg" class="orderList-tabs-img" />
              <span slot="title" class="orderList-tabs-fonts" >企业账户</span>
            </el-menu-item>
            <el-menu-item index="/statisticsList" :class="this.isopenStatistics?'is-active':''" style="height: 50px;line-height: 50px" >
              <div class="orderList-tabs-line" v-show="this.isopenStatistics" > </div>
              <span slot="title"   :class="this.isopenStatistics?'is-active-color':'orderList-tabs-font'">使用统计</span>
            </el-menu-item>
            <el-menu-item  style="pointer-events: none;height: 60px;line-height: 60px">
              <img src="../../static/images/付费管理.svg" class="orderList-tabs-img"/>
               <span slot="title" class="orderList-tabs-fonts">付费管理</span>
            </el-menu-item>
            <el-menu-item index="/orderList" @blur="itemBlur(this.isopenInvoice)" :class="this.isopenOrder?'is-active':''" style="height: 50px;line-height: 50px">
              <div class="orderList-tabs-line" v-show="this.isopenOrder" > </div>
              <span slot="title"  :class="this.isopenOrder?'is-active-color':'orderList-tabs-font'">我的订单</span>
            </el-menu-item>
             <el-menu-item index="/invoiceList" @blur="itemBlur(this.isopenInvoice)" :class="this.isopenInvoice?'is-active':''" style="height: 50px;line-height: 50px">
             <div class="orderList-tabs-line" v-show="this.isopenInvoice" > </div>
               <span slot="title" :class="this.isopenInvoice?'is-active-color':'orderList-tabs-font'">发票管理</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row >
    </div>
</template>
<script >
  export default {
    data() {
      return {
          isopenStatistics:false,
          isopenOrder:true,
          isopenInvoice:false,
          isRouter:true
      }
    },
    mounted() {
        var tempRouter = this.$router.currentRoute.path;
       // debugger
        switch(tempRouter) {
            case "/orderList":
                this.isopenOrder=true;
                this.isopenStatistics = false;
                this.isopenInvoice=false;
                //document.getElementsByClassName('.is-active-color').parentNode.setAttribute("style","background: rgba(246, 246, 246, 0.7) !important;");
                break;
            case "/invoiceList":
                this.isopenInvoice=true;
                this.isopenStatistics=false;
                this.isopenOrder=false;
                //document.getElementsByClassName('.is-active-color').parentNode.setAttribute("style","background: rgba(246, 246, 246, 0.7) !important;");
                break;
             case "/statisticsList":
               this.isopenStatistics=true;
               this.isopenOrder=false;
                this.isopenInvoice=false;
                //document.getElementsByClassName('.is-active-color').parentNode.setAttribute("style","background: rgba(246, 246, 246, 0.7) !important;");
                break;
            default:
                this.isopenStatistics = false;
                this.isopenOrder=false;
                this.isopenInvoice=false;
                 break;
        } 
        
    },
    methods: {
      itemBlur(){
        debugger
      }
        // openStatistics(){
        //   this.isopenStatistics = true;
        //   this.isopenOrder=false;
        //   this.isopenInvoice=false;
        //   console.log("openStatistics:"+this.isopenStatistics);
        // },
        // openOrder(){
        //     this.isopenOrder = true;
        //     this.isopenStatistics = false;
        //     this.isopenInvoice=false;
        //     console.log("openOrder:"+this.isopenOrder);
        // },
        // openInvoice(){
        //     this.isopenInvoice = true;
        //      this.isopenOrder = false;
        //     this.isopenStatistics = false;
        //     console.log("openInvoice:"+this.isopenInvoice );
        // }
    }

  }
</script>
<style lang="scss" >
  @import "../assets/style/mixin";
  .el-menu {
    border-right: solid 0px #e6e6e6 !important;
}
  .is-active-color{
    color:#287EFF !important;
    //background:rgba(246,246,246,0.7) !important;
    //background: #F6F6F6 !important;
    padding-left: 45px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px; 
    
  }
  li.el-menu-item:hover{
    //background: #F6F6F6 !important;
    //opacity: 0.7 !important;
     background:rgba(246,246,246,0.7) !important;
  }
li.el-menu-item:active {
   background: rgba(246,246,246,0.7) !important;
    //opacity: 0.7 !important;
    span {
        color: #287EFF !important;
      }

}

li.el-menu-item.is-active {
   background:rgba(246,246,246,0.7) !important; 
   color: #287EFF !important;
}
li.el-menu-item:focus{
  background: rgba(246,246,246,0.7) !important;
    //opacity: 0.7 !important;
    span {
        color: #287EFF !important;
      }
}
li.el-menu-item.is-active-color{
    color: #287EFF !important;
  }
   .orderList-tabs-div{
     width: 200px;
     min-width: 200px;
     height: 360px;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
  }
  .orderList-tabs-img{
    margin-left: 15px;
    position: absolute;
    margin-top: 20px;
    width: 18px;
    height: 18px;
  }
  .orderList-tabs-font{
      padding-left: 45px;
      height: 14px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      
  }
  
  .orderList-tabs-fonts{
      padding-left: 45px;
      height: 16px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
      cursor:default;
  }
  .orderList-tabs-line{
    border-left: 3px solid #287EFF;
    border-left-width: 3px;
    max-height: 30px;
    position: absolute;
    margin-left: -20px;
    margin-top: 13px;
    width: 3px;
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// navMenu.vue?75c0c5d8